import { ACTIONS, AuthRoutes, USERTYPES } from "./Constants";


//BREAD CRUMB ITEMS FOR ADMIN AND FIRMADMIN PAGE
export const addEditAdminBreadCrumbItems = (props, userType, t, firmID) => [
  {
    text: t("admin.admin"),
    key: "admin",
    href: `${
      userType === USERTYPES.ADMIN
        ? AuthRoutes.ADMINUSERLIST
        : AuthRoutes.FIRMADMINUSERLIST+"?firmId="+firmID
    }`,
  },
  {
    text: `${
      props.action === ACTIONS.ADD
        ? t("admin.add-admin")
        : (props.action === ACTIONS.EDIT)? t("admin.edit-admin")
        : "View Admin"
    }`,
    key: "add-edit-admin",
  },
];

//BREAD CRUMB ITEMS FOR SUPERVISOR PAGE
export const addEditSupervisorBreadCrumbItems = (props, t, firmID) => [
  {
    text: t("supervisor.supervisor"),
    key: "supervisor",
    href: AuthRoutes.SUPERVISORLIST+"?firmId="+firmID,
  },
  {
    text: `${
      props.action === ACTIONS.ADD
        ? t("supervisor.add-supervisor")
        : (props.action === ACTIONS.EDIT)? t("supervisor.edit-supervisor")
        : "View Supervisor"
    }`,
    key: "add-edit-supervisor",
  },
];

//BREAD CRUMB ITEMS FOR FIRM DOCTOR PAGE
export const addEditFirmDoctorBreadCrumbItems = (props, t, firmID) => [
  {
    text: t("firmdoctor.firmdoctor"),
    key: "firmdoctor",
    href: AuthRoutes.FIRMDOCTORLIST+"?firmId="+firmID,
  },
  {
    text: `${
      props.action === ACTIONS.ADD
        ? t("firmdoctor.add-firmdoctor")
        : (props.action === ACTIONS.EDIT)? t("firmdoctor.edit-firmdoctor")
        : "View Firm Doctor"
    }`,
    key: "add-edit-firmdoctor",
  },
];

//BREAD CRUMB ITEMS FOR FIRM TECHNICIAN PAGE
export const addEditFirmTechnicianBreadCrumbItems = (props, t, firmID) => [
  {
    text: t("firmtechnician.firmtechnician"),
    key: "firmtechnician",
    href: AuthRoutes.FIRMTECHNICIANLIST+"?firmId="+firmID,
  },
  {
    text: `${
      props.action === ACTIONS.ADD
        ? t("firmtechnician.add-firmtechnician")
        : (props.action === ACTIONS.EDIT)? t("firmtechnician.edit-firmtechnician")
        : "View Firm Technician"
    }`,
    key: "add-edit-firmtechnician",
  },
];

//BREAD CRUMB ITEMS FOR FIRM TECHNICIAN PAGE
export const addEditRadiologistBreadCrumbItems = (props, loggedInUserRole, t) => [
  {
    text: t("radiologist.radiologist"),
    key: "radiologist",
    href: `${
      loggedInUserRole === USERTYPES.ADMIN
        ? AuthRoutes.ADMINRADIOLOGISTLIST
        : AuthRoutes.RADIOLOGISTLIST
    }`,
  },
  {
    text: `${
      props.action === ACTIONS.ADD
        ? t("radiologist.add-radiologist")
        : (props.action === ACTIONS.EDIT)? t("radiologist.edit-radiologist")
        : "View Radiologist"
    }`,
    key: "add-edit-radiologist",
  },
];

//VIEW ADMIN BREAD CRUMB ITEMS
export const viewAdminBreadCrumbItems = (state,t) => [
  {
    text: t("admin.admin"),
    key: "admin",
    href: `${
      state.userType === USERTYPES.ADMIN
        ? AuthRoutes.ADMINUSERLIST
        : AuthRoutes.FIRMADMINUSERLIST
    }`,
  },
  {
    text: t("admin.view-admin"),
    key: "view-admin",
  },
];

//VIEW SUPERVISOR BREAD CRUMB ITEMS
export const viewSupervisorBreadCrumbItems = (t) => [
  {
    text: t("supervisor.supervisor"),
    key: "admin",
    href: AuthRoutes.SUPERVISORLIST,
  },
  {
    text: t("supervisor.view-supervisor"),
    key: "view-supervisor",
  },
];

//VIEW FIRMDOCTOR BREAD CRUMB ITEMS
export const viewFirmDoctorBreadCrumbItems = (t) => [
  {
    text: t("firmdoctor.firmdoctor"),
    key: "firmdoctor",
    href: AuthRoutes.FIRMDOCTORLIST,
  },
  {
    text: t("firmdoctor.view-firmdoctor"),
    key: "view-firmdoctor",
  },
];

//VIEW FIRM TECHNICIAN BREAD CRUMB ITEMS
export const viewFirmTechnicianBreadCrumbItems = (t) => [
  {
    text: t("firmtechnician.firmtechnician"),
    key: "firmtechnician",
    href: AuthRoutes.FIRMTECHNICIANLIST,
  },
  {
    text: t("firmtechnician.view-firmtechnician"),
    key: "view-firmtechnician",
  },
];

//VIEW HOSPITAL DOCTOR BREAD CRUMB ITEMS
export const viewHospitalDoctorBreadCrumbItems = (t) => [
  {
    text: "Hospital Doctor",
    key: "firmdoctor",
    href: AuthRoutes.FIRMDOCTORLIST,
  },
  {
    text: "View Hospital Doctor",
    key: "view-firmdoctor",
  },
];

//VIEW HOSPITAL TECHNICIAN BREAD CRUMB ITEMS
export const viewHospitalTechnicianBreadCrumbItems = (t) => [
  {
    text: "Hospital User",
    key: "firmtechnician",
    href: AuthRoutes.FIRMTECHNICIANLIST,
  },
  {
    text: "View Hospital User",
    key: "view-firmtechnician",
  },
];

//VIEW RADIOLOGIST BREAD CRUMB ITEMS
export const viewRadiologistBreadCrumbItems = (state,t) => [
  {
    text: t("radiologist.radiologist"),
    key: "radiologist",
    href: `${
      state.loggedInUserRole === USERTYPES.ADMIN
        ? AuthRoutes.ADMINRADIOLOGISTLIST
        : AuthRoutes.RADIOLOGISTLIST
    }`,
  },
  {
    text: t("radiologist.view-radiologist"),
    key: "view-radiologist",
  },
];

export const changePasswordBreadCrumbItems = () => [
  {
    text: "Change Password",
    key: "change-password"
  }
];

//BREAD CRUMB ITEMS FOR TYPIST PAGE
export const addEditTypistBreadCrumbItems = (props, t, firmID) => [
  {
    text: t("typist.typists"),
    key: "typist",
    href: AuthRoutes.TYPISTUSERLIST
  },
  {
    text: `${
      props.action === ACTIONS.ADD
        ? t("typist.add-typist")
        : (props.action === ACTIONS.EDIT)? t("typist.edit-typist")
        : "View Typist"
    }`,
    key: "add-edit-typist",
  },
];